import { useField } from "formik";
import React from "react";
import { Form, Label } from "semantic-ui-react";

interface Props {
    placeholder?: any;
    name: string;
    type?: string;
    label?: string;
    value?: any;
    id?: string;
    className?: string;
    readOnly?: any;
    defaultValue?: any;
    maxlength?: any;
    onChange?: any;
}
interface PropsEdiciones {
    placeholder: string;
    name: string;
    type?: string;
    label?: string;
    value?: any;
    id?: string;
    className?: string;
    readOnly?: any;
    maxlength?: any;
    onChange?: any;
    onInput?: any;
}

interface PropsFechas {
    placeholder?: any;
    name: string;
    type?: string;
    label?: string;
    value?: any;
    id?: string;
    className?: string;
    maxlength?: any;
    defaultValue?: any;
    readOnly?: any;
    onValue?: any;
    onChange?: any;
    onInput?: any;
    onBlur?: any;
    onFocus?: any;
}

interface PropsNext {
    placeholder?: string;
    name: string;
    type?: string;
    label?: string;
    value?: any;
    className?: string;
}

interface PropsTextArea {
    placeholder?: string;
    name: string;
    type?: string;
    label?: string;
    value?: any;
    id?: string;
    className?: string;
    as?: string;
    rows?: number;
    defaultValue?: string;
    onChange?: any;
    readOnly?: any;
}

export function MyTextAreatConv(props: PropsTextArea) {
    const [field, meta, onChange] = useField(props.name);
    return (
        <Form.Field error={meta.touched && !!meta.error}>
            <label>{props.label}</label>
            <textarea {...field} {...props} {...onChange} id={props.id} value={props.value} rows={6} readOnly={props.readOnly}/>
            {meta.touched && meta.error ? (
                <Label basic color='red'>{meta.error}</Label>
            ) : null}
        </Form.Field>
    )
}

export function MyTextInputConv(props: Props) {
    const [field, meta, onChange] = useField(props.name);
    return (
        <Form.Field error={meta.touched && !!meta.error}>
            <label key={props.label}>{props.label}</label>
            <input {...field} {...props} {...onChange} id={ props.id } value={ props.value } key={props.id}/>
            {meta.touched && meta.error ? (
                <Label basic color='red'>{meta.error}</Label>
            ) : null}
        </Form.Field>
    )
}

export function MyTextAreatConvD (props: PropsTextArea) {
    const [field, meta, onChange] = useField(props.name);
    return (
        <Form.Field error={meta.touched && !!meta.error}>
            <label>{props.label}</label>
            <textarea {...field} {...props} {...onChange} id={props.id} value={props.value} rows={6} defaultValue={props.defaultValue} readOnly={props.readOnly} className={props.className}/>
            {meta.touched && meta.error ? (
                <Label basic color='red'>{meta.error}</Label>
            ) : null}
        </Form.Field>
    )
}

export function MyTextInputConvD(props: Props) {
    const [field, meta, onChange] = useField(props.name);
    return (
        <Form.Field error={meta.touched && !!meta.error}>
            <label>{props.label}</label>
            <input {...field} {...props} {...onChange} id={props.id} type={props.type} value={props.value} />
            {meta.touched && meta.error ? (
                <Label basic color='red'>{meta.error}</Label>
            ) : null}
        </Form.Field>
    )
}

export function MyTextInput(props: Props) {
    const [field, meta] = useField(props.name);
    return (
        <Form.Field error={meta.touched && !!meta.error}>
            <label>{props.label}</label>
            <input {...field} {...props} defaultValue={props.defaultValue} value={props.value} id={props.id} type={props.type} autoComplete="nope"/>
            {meta.touched && meta.error ? (
                <Label basic color='red'>{meta.error}</Label>
            ) : null}
        </Form.Field>
    )
}

export function MyTextInputRemplazo(props: PropsEdiciones) {
    const [field, meta] = useField(props.name);
    return (
        <Form.Field error={meta.touched && !!meta.error}>
            <label>{props.label}</label>
            <input {...field} {...props} id={props.id} style={{ backgroundColor: "#E9E9E7", border: "none" }} type={props.type} />
            {meta.touched && meta.error ? (
                <Label basic color='red'>{meta.error}</Label>
            ) : null}
        </Form.Field>
    )
}

export function MyTextInputFechas(props: PropsFechas) {
    const [field, meta, onChange] = useField(props.name);
    return (
        <Form.Field error={meta.touched && !!meta.error}>
            <label>{props.label}</label>
            <input {...field} {...props} {...onChange} id={props.id} readOnly={props.readOnly} type={props.type} value={props.value} defaultValue={props.defaultValue} onFocus={props.onFocus} onBlur={props.onValue}/>
            {meta.touched && meta.error ? (
                <Label basic color='red'>{meta.error}</Label>
            ) : null}
        </Form.Field>
    )
}

export function MyTextInputMayusculas(props: PropsNext) {
    const [field, meta] = useField(props.name);
    return (
        <Form.Field error={meta.touched && !!meta.error}>
            <label>{props.label}</label>
            <input {...field} {...props} style={{ backgroundColor: "#E9E9E7", border: "none", textTransform: "uppercase" }} type={props.type} />
            {meta.touched && meta.error ? (
                <Label basic color='red'>{meta.error}</Label>
            ) : null}
        </Form.Field>
    )
}

export default function MyTextInputBasic(props: Props) {
    const [field, meta] = useField(props.name);
    return (
        <Form.Field error={meta.touched && !!meta.error}>
            <label>{props.label}</label>
            <input  {...field} {...props} id={props.id} type={props.type} style={{ backgroundColor: "#E9E9E7", border: "none" }} autoComplete="nope" />
            {meta.touched && meta.error ? (
                <Label basic color='red'>{meta.error}</Label>
            ) : null}
        </Form.Field>
    )
}

